(function () {
  function init(nav) {
    if (nav.dataset.collectionsNavInit === 'true') return;
    nav.dataset.collectionsNavInit = 'true';

    const list = nav.querySelector('.collections-nav__list');
    const dotsContainer = nav.querySelector('.collections-nav__dots');
    if (!list || !dotsContainer) return;

    const buttons = Array.from(list.querySelectorAll('.collections-nav__button'));
    const dots = Array.from(dotsContainer.querySelectorAll('.collections-nav__dot'));
    if (!buttons.length || !dots.length || buttons.length !== dots.length) return;

    let activeIndex = -1;
    let scrollRaf = null;

    function setActive(index) {
      if (index === activeIndex) return;
      activeIndex = index;
      dots.forEach((dot, i) => {
        const isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    }

    function updateActive() {
      const viewportCenter = list.scrollLeft + list.clientWidth / 2;
      let nearest = 0;
      let nearestDist = Infinity;
      buttons.forEach((btn, i) => {
        const btnCenter = btn.offsetLeft - list.offsetLeft + btn.clientWidth / 2;
        const dist = Math.abs(btnCenter - viewportCenter);
        if (dist < nearestDist) {
          nearestDist = dist;
          nearest = i;
        }
      });
      setActive(nearest);
    }

    function onScroll() {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(() => {
        scrollRaf = null;
        updateActive();
      });
    }

    list.addEventListener('scroll', onScroll, { passive: true });

    dotsContainer.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-dot-index]');
      if (!btn) return;
      const index = Number(btn.dataset.dotIndex);
      const target = buttons[index];
      if (!target) return;
      const left = target.offsetLeft - list.offsetLeft - (list.clientWidth - target.clientWidth) / 2;
      list.scrollTo({ left, behavior: 'smooth' });
    });

    updateActive();
  }

  function initAll() {
    document.querySelectorAll('[data-collections-nav]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
